// extracted by mini-css-extract-plugin
module.exports = {"container":"productContainer_container__VufON","mainInfo":"productContainer_mainInfo__ilECH","gallery":"productContainer_gallery__MFLoG","info":"productContainer_info__2f35P"};